import { createFeatureSelector, createSelector } from '@ngrx/store';
import {
  BOOK_PROGRESS_FEATURE_KEY,
  BookProgressState,
  bookProgressAdapter,
} from './book-progress.reducer';
import { selectParamBookId } from '../book/book.selectors';
import { CallState, getError, LoadingState } from '@lyceo/shared/util-loading';

export const selectBookProgressState = createFeatureSelector<BookProgressState>(
  BOOK_PROGRESS_FEATURE_KEY,
);

const { selectAll } = bookProgressAdapter.getSelectors();

export const selectAllBookProgresses = createSelector(
  selectBookProgressState,
  (state: BookProgressState) => selectAll(state),
);

export const selectParamBookProgress = createSelector(
  selectAllBookProgresses,
  selectParamBookId,
  (bookProgresses, bookId) =>
    bookProgresses.find((bookProgress) => bookProgress.bookId === bookId),
);

export const selectBookProgressFullyLoadedIds = createSelector(
  selectBookProgressState,
  (state: BookProgressState) => state.fullyLoadedIds,
);

export const selectParamBookProgressLoaded = createSelector(
  selectParamBookId,
  selectBookProgressFullyLoadedIds,
  (paramBookId, fullyLoadedIds) =>
    paramBookId ? fullyLoadedIds.includes(paramBookId) : false,
);

export const selectTocBookProgressCallState = createSelector(
  selectBookProgressState,
  (state) => state.tocCallState,
);

export const selectTocBookProgressLoading = createSelector(
  selectTocBookProgressCallState,
  (callState: CallState) => callState === LoadingState.LOADING,
);

export const selectTocBookProgressError = createSelector(
  selectTocBookProgressCallState,
  (callState: CallState) => getError(callState),
);
